import type { IInheritanceReuseFilterCondition } from "@/features/inheritanceReuse/types";
import {
  DISTANCE_CATEGORY_OPTIONS,
  REAL_ESTATE_TYPE_OPTIONS,
} from "@/features/inheritanceReuse/utils/constants";

const labelOf = (
  options: Array<{ value: string; label: string }>,
  value: string
): string => options.find((o) => o.value === value)?.label ?? value;

/** 数値文字列を ja-JP 桁区切りへ。空文字・非数値は "…"。 */
const groupDigits = (value: string): string => {
  if (value.trim() === "") return "…";
  const n = Number(value);
  return Number.isFinite(n) ? n.toLocaleString("ja-JP") : "…";
};

/**
 * 検索確定済みフィルタを、コンパクトなサマリ用の短いラベル配列へ変換する。
 * 未指定の項目は含めない。都道府県は必須なので先頭に必ず入る。
 */
export const summarizeFilter = (
  filter: IInheritanceReuseFilterCondition
): string[] => {
  const chips: string[] = [];

  if (filter.prefectureName !== "") chips.push(filter.prefectureName);
  if (filter.cityName !== "") chips.push(filter.cityName);
  if (filter.realEstateType !== "")
    chips.push(labelOf(REAL_ESTATE_TYPE_OPTIONS, filter.realEstateType));
  if (filter.distanceCategory !== "")
    chips.push(labelOf(DISTANCE_CATEGORY_OPTIONS, filter.distanceCategory));
  if (filter.minSaleRank !== "")
    chips.push(`売却期待度${"★".repeat(Number(filter.minSaleRank))}以上`);
  if (filter.minInheritanceScore !== "")
    chips.push(`次相続スコア${filter.minInheritanceScore}以上`);
  if (filter.isOccupant) chips.push("居住のみ");
  if (filter.emptyHouse) chips.push("空き家のみ");
  if (filter.maxOwnerCount !== "")
    chips.push(`所有者数${filter.maxOwnerCount}以下`);
  if (filter.acquiredFrom !== "" || filter.acquiredTo !== "") {
    chips.push(
      `取得日 ${filter.acquiredFrom || "…"}〜${filter.acquiredTo || "…"}`
    );
  }
  if (filter.inheritanceFrom !== "" || filter.inheritanceTo !== "") {
    chips.push(
      `相続登記日 ${filter.inheritanceFrom || "…"}〜${
        filter.inheritanceTo || "…"
      }`
    );
  }
  if (filter.buildYearFrom !== "" || filter.buildYearTo !== "") {
    chips.push(
      `築年 ${filter.buildYearFrom || "…"}〜${filter.buildYearTo || "…"}`
    );
  }
  if (
    filter.minEstimatedLandValue !== "" ||
    filter.maxEstimatedLandValue !== ""
  ) {
    chips.push(
      `推定土地評価額 ${groupDigits(
        filter.minEstimatedLandValue
      )}〜${groupDigits(filter.maxEstimatedLandValue)}円`
    );
  }

  return chips;
};
